<div class="no-results-container text-center pt-5 pb-5 d-flex flex-column align-items-center">
  <img class="no-results-image img-fluid"
    [src]="baseImagePath + '/pubweb/marketplace/images/backgrounds/no-results.svg'">
  <p class="subhead-text text-grey pt-5">Sorry, we couldn’t dig up any results.</p>
    <div class="p-4 bg-light-grey d-flex flex-column align-items-center no-results-subtext">
      <div>
        <div class="d-flex section-header header-text">
          <p class="p-0 prompt-font">We're here to help you every step of the way. Email or call us directly and we'll check our extensive network to locate the machine you're looking for.</p>
        </div>
      </div>
      <div class="d-flex mobile-no-result">
        <div class="d-flex align-items-center mr-2">
          <div class="icon-container d-inline">
            <i class="icon-phone text-grey fs-30 mr-1"></i>
          </div>
          <div class="d-inline align-self-center text-green">
            <a href="tel:(866) 455-8531">1 (866) 455-8531</a>
          </div>
        </div>
        <div class="d-flex align-items-center ml-2">
          <div class="icon-container d-inline">
            <i class="icon-envelope text-grey fs-30 mr-2"></i>
          </div>
          <div class="d-inline-flex align-self-center text-green">
            <a href="mailto:{{'support@rubbl.com'}}">support@rubbl.com</a>
          </div>      
        </div>
      </div>
    </div>
</div>
<div class="bt-light pt-4" *ngIf="similarResults != null && similarResults.length > 0">
  <app-card-carousel header="Similar Results" cardComponentName="MachineCardAdvancedComponent"
    [slidesPerViewConfig]="slidesPerViewConfig" [cardData]="similarResults">
  </app-card-carousel>
</div>